// extracted by mini-css-extract-plugin
export default {"dropZone":"DropZone_dropZone__XWosL","dropZoneTextGroup":"DropZone_dropZoneTextGroup__Vioij"};